import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { jwtDecode } from 'jwt-decode';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Helmet } from "react-helmet-async";


const HasilUjian = () => {
    const location = useLocation(); // Gunakan useLocation untuk membaca query string

    const queryParams = new URLSearchParams(location.search);

    const kode = queryParams.get('kode');

    const [dataPeserta, setDataPeserta] = useState([]); // State untuk menyimpan daftar kelas
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const [dataSoal, setDatasoal] = useState([]); // State untuk menyimpan daftar kelas

    const [dataUjian, setDataUjian] = useState([]);


    const getDataRefrensi = useCallback(async () => {
        try {
            // Kirim request ke server dengan header level user
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/getjawbaan?kode=${kode}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch kelas");
            }

            const data = await response.json();
            setDataPeserta(data.dataJawaban)

            setDatasoal(data.dataSoal)

            setDataUjian(data.dataUjian)

        } catch (error) {
            setError(error.message || 'Something went wrong');
        }
    }, []);


    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
            console.error("Token required");
            return; // Jika tidak ada token, hentikan eksekusi
        }

        try {
            // Decode payload dari token JWT
            const decoded = jwtDecode(authToken);


        } catch (error) {
            console.error("Invalid token:", error);
            navigate('/login'); // Jika token tidak valid, arahkan ke halaman login
            return;
        }


    }, []);
    useEffect(() => {
        getDataRefrensi(); // Ambil data referensi awal



        // Inisialisasi ulang DataTables setelah data diperbarui
        if (dataPeserta?.jadwal?.length > 0) {
            if ($.fn.dataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy(); // Hancurkan DataTable yang lama
            }

            $('.table').DataTable({
                "dom": "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
                "language": {
                    "search": "",
                    "lengthMenu": "_MENU_"
                },
            });
        }
    }, []); // Pastikan efek hanya berjalan saat data berubah
    // Inisialisasi ulang hanya ketika `kelas` berubah



    dataSoal.forEach(item => {
        console.log(`ID: ${item.id}, Point:`, item.point, "Type:", typeof item.point);
    });
    const jmls = dataSoal.length;
    const totalskor = dataSoal.reduce((acc, item) => acc + (parseFloat(item.poin) || 0), 0);
    dataSoal.map((d) => {
        console.log("fff" + d.poin || 0)

    })
    const exportToExcel = async () => {
        if (dataPeserta && dataPeserta.length > 0) {
            let hasilData = dataPeserta.map((item, index) => {
                let totalBenar = 0;
                let skor = 0;

                if (item.jawaban) {
                    let jawabanArray = [];
                    try {
                        jawabanArray = JSON.parse(item.jawaban);
                    } catch (error) {
                        console.error("Error parsing jawaban:", error);
                    }

                    if (Array.isArray(jawabanArray)) {
                        jawabanArray.forEach((jawabanItem) => {
                            const soalCocok = dataSoal.find((s) => s.id_soal === jawabanItem.idsoal);

                            if (soalCocok) {
                                const jawabanSoal = JSON.parse(soalCocok.jawaban || "[]");
                                const jawabanBenarArr = jawabanSoal
                                    .filter((s) => s.kunci === 1)
                                    .map((s) => s.id_jwb.toString());

                                const jawabanUserArr = Array.isArray(jawabanItem.jawaban)
                                    ? jawabanItem.jawaban.map((s) => s.id_jwb.toString())
                                    : [jawabanItem.jawaban.id_jwb];

                                const isJawabanBenar =
                                    jawabanUserArr.length === jawabanBenarArr.length &&
                                    jawabanUserArr.every((jawaban) => jawabanBenarArr.includes(jawaban));

                                if (isJawabanBenar) {
                                    totalBenar += 1;
                                    let poin = parseFloat(soalCocok.poin);
                                    skor += isNaN(poin) ? 1 : poin; // Gunakan 1 jika poin tidak ada
                                }
                            }
                        });
                    }
                }

                return {
                    "#": index + 1,
                    "Nama": item.nama_peserta,
                    "Skor / Total Skor (100)": `${skor} / ${totalskor} (${Math.floor((skor / totalskor) * 100)}%)`,
                    "Benar / Jumlah Soal (100)": `${totalBenar} / ${jmls} (${Math.floor((totalBenar / jmls) * 100)}%)`,
                };
            });

            let hasilDatadetail = dataPeserta.map((item, index) => {
                let rowData = {
                    "#": index + 1,
                    "Nama": item.nama_peserta,
                };
                let totalBenar = 0;
                let skor = 0;
                if (item.jawaban) {
                    let jawabanArray = [];
                    try {
                        jawabanArray = JSON.parse(item.jawaban);
                    } catch (error) {
                        console.error("Error parsing jawaban:", error);
                    }

                    if (Array.isArray(jawabanArray)) {
                        jawabanArray.forEach((jawabanItem, idx) => {
                            const soalCocok = dataSoal.find((s) => s.id_soal === jawabanItem.idsoal);
                            if (soalCocok) {
                                const jawabanSoal = JSON.parse(soalCocok.jawaban || "[]");
                                const jawabanBenarArr = jawabanSoal
                                    .filter((s) => s.kunci === 1)
                                    .map((s) => s.id_jwb.toString());

                                const jawabanUserArr = Array.isArray(jawabanItem.jawaban)
                                    ? jawabanItem.jawaban.map((s) => s.id_jwb.toString())
                                    : [jawabanItem.jawaban.id_jwb];

                                const isJawabanBenar =
                                    jawabanUserArr.length === jawabanBenarArr.length &&
                                    jawabanUserArr.every((jawaban) => jawabanBenarArr.includes(jawaban));

                                if (isJawabanBenar) {
                                    totalBenar += 1;
                                    let poin = parseFloat(soalCocok.poin);
                                    skor += isNaN(poin) ? 1 : poin; // Gunakan 1 jika poin tidak ada
                                    rowData[`Soal ${idx + 1}`] = parseFloat(soalCocok.poin) || "-";


                                } else {
                                    rowData[`Soal ${idx + 1}`] = "0" || "-";
                                }
                            }
                        });
                    }
                }
                rowData[`Total`] = skor

                return rowData;
            });



            const workbook = XLSX.utils.book_new();
            const summarySheet = XLSX.utils.json_to_sheet(hasilData);
            XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");

            const detailSheet = XLSX.utils.json_to_sheet(hasilDatadetail);
            XLSX.utils.book_append_sheet(workbook, detailSheet, "Details");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            const fileData = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            saveAs(fileData, "table_data.xlsx");
        } else {
            console.warn("Data peserta tidak tersedia");
        }
    };


    return (
        <>
            <Helmet>
                <title>Verifikasi OTP Griya Vidya</title>
            </Helmet>
            <div>
                <div className="pc-container">
                    <div className="pc-content">
                        <div className="row">
                            <div className="col-xl-12 col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Ujian</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row g-4">
                                            <div className="col-md-4">
                                                <h5>Pendidik</h5>
                                                <hr />
                                                <h5>{dataUjian.nama_guru}</h5>
                                            </div>
                                            <div className="col-md-4">
                                                <h5>Kelas</h5>
                                                <hr />
                                                <h5>{dataUjian.nama_rombel}</h5>
                                            </div>
                                            <div className="col-md-4">
                                                <h5>Pelajaran</h5>
                                                <hr />
                                                <h5>{dataUjian.nama_mapel}</h5>
                                            </div>
                                            <div className="col-md-4">
                                                <h5>Jumlah Soal</h5>
                                                <hr />
                                                <h5>{jmls}</h5>
                                            </div>
                                            <div className="col-md-4">
                                                <h5>Total Poin</h5>
                                                <hr />
                                                <h5>{totalskor}</h5>
                                            </div>

                                            <div className="col-md-4">
                                                <h5>Jumlah Peserta</h5>
                                                <hr />
                                                <h5>{dataPeserta ? dataPeserta.length : "Loading..."} </h5>
                                            </div>
                                        </div>
                                        <hr />
                                        <a href={`/pendidik/viewevaluasi?id_ujian=${dataUjian.id_ujian}`} className="btn btn-primary d-inline-flex"><i className='ti ti-file-invoice'></i> Daftar Soal</a>
                                        <button className='btn btn-secondary' onClick={exportToExcel}>Download Hasil Excel</button>
                                        {/* <a  href='#baru' className="btn btn-primary d-inline-flex"><i className='ti ti-arrows-join'></i> Sycron Hasil</a> */}


                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-12 col-md-12">
                                <div className="card">

                                    <div className="card-body">
                                        <div className='row mb-3 align-items-center'>
                                            <div className="col"><small className="text-muted">Refrensi</small><h3>Hasil Tes</h3></div>

                                            <div className='col-auto'>
                                                {/* <button data-bs-toggle="modal" data-bs-target="#ujianModal"  type="button" className="btn btn-primary d-inline-flex"><i className="ti ti-plus me-1"></i>Download Hasil</button> */}
                                            </div>
                                        </div>
                                        <hr />
                                        {/* Tabel kelas */}
                                        <table className="table table-hover datatable-table">
                                            <thead>
                                                <tr>
                                                    <th width="50">#</th>
                                                    <th scope="col">Peserta</th>
                                                    <th width="50">Durasi</th>
                                                    <th width="50">Skor (/100)</th>
                                                    <th width="50"><center>Jawaban Benar (/100)</center></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Render data peserta */}
                                                {dataPeserta?.map((item, index) => {
                                                    let totalBenar = 0; // Menyimpan jumlah jawaban benar
                                                    let skor = 0;
                                                    let poinlalu = 0;
                                                    return (
                                                        <tr key={item.id}>
                                                            <td scope="row">{index + 1}</td>
                                                            <td><b>{item.nama_peserta}</b></td>
                                                            <td><b>{item.durasi || "-"}</b></td>
                                                            <td>
                                                                <b>
                                                                    {item.jawaban && Array.isArray(JSON.parse(item.jawaban)) ? (
                                                                        JSON.parse(item.jawaban).map((jawabanItem) => {
                                                                            const soalCocok = dataSoal.find((s) => s.id_soal === jawabanItem.idsoal);

                                                                            if (soalCocok) {


                                                                                const jawabanSoal = JSON.parse(soalCocok.jawaban || "[]");
                                                                                const jawabanBenarArr = jawabanSoal
                                                                                    .filter((s) => s.kunci === 1)
                                                                                    .map((s) => s.id_jwb.toString());

                                                                                const jawabanUserArr = Array.isArray(jawabanItem.jawaban)
                                                                                    ? jawabanItem.jawaban.map((s) => s.id_jwb.toString())
                                                                                    : [jawabanItem.jawaban.id_jwb];

                                                                                const isJawabanBenar =
                                                                                    jawabanUserArr.length === jawabanBenarArr.length &&
                                                                                    jawabanUserArr.every((jawaban) => jawabanBenarArr.includes(jawaban));


                                                                                if (isJawabanBenar) {
                                                                                    totalBenar += 1;
                                                                                    poinlalu = soalCocok.poin || 1;
                                                                                    skor += parseFloat(soalCocok.poin) || poinlalu; // Jika poin tidak ada, gunakan 0 agar tidak error
                                                                                    // console.log(item.nama_peserta + "-" + skor)
                                                                                }
                                                                            }

                                                                        })
                                                                    ) : (
                                                                        "Tidak ada jawaban"
                                                                    )} {skor} ({Math.floor((skor / totalskor) * 100)})


                                                                </b>
                                                            </td>
                                                            <td><b>{totalBenar} ({Math.floor((totalBenar / jmls) * 100)})</b></td> {/* Menampilkan jumlah jawaban benar */}
                                                            <td></td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default HasilUjian;
